import { CompositeFilterDescriptor } from '@progress/kendo-data-query';

export const externalFilter: {
  filters: CompositeFilterDescriptor[];
}[] = [
  {
    filters: [
      {
        logic: 'and',
        filters: [],
      },
    ],
  },
  // Temporarily hidden — re-enable with "Only Contracted Items" in productFilterCategories.ts (value 1)
  // {
  //   filters: [
  //     {
  //       filters: [{ field: 'isContracted', value: true, operator: 'eq' }],
  //       logic: 'and',
  //     },
  //   ],
  // },
];
